import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledModal,
    StyledLabel,
    CheckboxIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { mutate } from "swr";

import { store as useStore } from "@components/VerticalLayout/store";

import { capitalize } from "../../../helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

export function ConfirmationModalActivedApplication({
    isConfirmationModalActived,
    setIsConfirmationModalActived,
    setIsDataUpdated,
    selectedRows,
}: {
    isConfirmationModalActived: boolean;
    setIsConfirmationModalActived: Function;
    setIsDataUpdated: Function;
    selectedRows: any;
}) {
    const { t } = useTranslation();
    const { shopID, oneShop, userID, franchiseID, operatorID } = useSnapshot(
        useStore
    );

    async function activeApplication() {
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/application/kds`;
        const appId: string = "KDS";
        let data = {
            userId: userID,
            shopId: oneShop ? shopID : selectedRows[0]?.shopId,
            franchiseId: franchiseID,
            operatorId: operatorID,
            type: "Désarchivage",
            data: {
                [appId]: {
                    id_application: appId,
                    data_app: {
                        [selectedRows[0]?.appId]: {
                            id_application_children: selectedRows[0]?.appId,
                            printer: selectedRows[0].printer,
                            designation: selectedRows[0][t("Application")],
                            ip: selectedRows[0][t("Address IP")],
                            note: selectedRows[0][t("Note")],
                            typeOfKDS: selectedRows[0][t("Type of KDS")],
                            isArchived: false,
                        },
                    },
                },
            },
        };
        try {
            fetch(apiUrlAdd, {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bareer ${localStorage.getItem("jwt")}`,
                },
                body: JSON.stringify(data),
                method: "POST",
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        throw Error("error");
                    }
                    toast.success(
                        `${t("This application was successfully unarchived")!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            theme: "colored",
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                    setIsConfirmationModalActived(!isConfirmationModalActived);
                    setIsDataUpdated!(true);
                });
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    async function activedApplications() {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/kds`;
        let localData: any = [];
        const appId: string = "KDS";
        selectedRows.forEach((row: any) => {
            if (row.appId !== undefined) {
                let data = {
                    userId: userID,
                    shopId: oneShop ? shopID : row.shopId,
                    franchiseId: franchiseID,
                    operatorId: operatorID,
                    type: "Désarchivage",
                    data: {
                        [appId]: {
                            id_application: appId,
                            data_app: {
                                [row?.appId]: {
                                    id_application_children: row?.appId,
                                    printer: row.printer,
                                    designation: row[t("Application")],
                                    ip: row[t("Address IP")],
                                    note: row[t("Note")],
                                    typeOfKDS: row[t("Type of KDS")],
                                    isArchived: false,
                                },
                            },
                        },
                    },
                };
                localData.push(
                    fetch(apiUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                    }).then((response) => response.json())
                );
            }
        });
        try {
            mutate(
                apiUrl,
                await Promise.all(localData).then((result: any) => {
                    let errors: boolean[] = result.map((el: any) => el.error);
                    if (!errors.includes(true)) {
                        toast.success(
                            `${t(
                                "This application was successfully unarchived"
                            )!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 2000,
                                theme: "colored",
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                        setIsConfirmationModalActived(
                            !isConfirmationModalActived
                        );
                        setIsDataUpdated(true);
                    } else {
                        throw Error(result.message);
                    }
                })
            );
        } catch (e: any) {
            toast.error(`${t("There's an error")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    return (
        <StyledModal
            toggle={true}
            isOpen={isConfirmationModalActived!}
            centered
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsConfirmationModalActived(!isConfirmationModalActived);
                    setIsDataUpdated(true);
                }}
            >
                <span>{capitalize(t("Alert"))}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "Do you want to confirm the unarchiving of the selected application?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsConfirmationModalActived(
                            !isConfirmationModalActived
                        );
                        setIsDataUpdated(true);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        selectedRows.length > 1
                            ? activedApplications()
                            : activeApplication();
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
